"use client";

import { H3 } from "../h3";
import { Link } from "../link";

type NavLogoProps = {
  href?: string;
  className?: string;
};

export function NavLogo({ href = "/", className }: NavLogoProps) {
  return (
    <Link
      href={href}
      className={`font-display text-black hover:no-underline ${className || ""}`}
    >
      <H3>Yardzen</H3>
    </Link>
  );
}
